module.exports = __webpack_public_path__ + "img/bolivia-(plurinational-state-of).66458d89.svg";